import { AppliedFilters } from './FilterSearch';

export enum Frequency {
  DAILY = '1',
  WEEKLY = '7',
}
export interface StockAlert
  extends Omit<
    AppliedFilters,
    | 'branchId'
    | 'branchName'
    | 'deposit'
    | 'dor'
    | 'evCampaign'
    | 'locationLat'
    | 'locationLng'
    | 'page'
    | 'promotion'
    | 'sortOrder'
    | 'unreservedOnly'
  > {
  frequency: Frequency | null;
}

export interface ApiStockAlert {
  count: number;
  createdAt: string;
  frequency: Frequency;
  name: string | null;
  savedSearch: StockAlert;
  url: string;
  uuid: string;
}
